module.exports = __webpack_public_path__ + "media/images/expand-icon-2fd738e31186bca21a68ce34fd9e0df2.svg";